import SEO from "@/components/SEO";
import { RegisterForm } from "@/components/RegisterForm";

const COPY = {
  title: "Join the Lumière list | Lumière Aesthetics Cottesloe",
  description: "Physician introductions, journal articles and appointment availability from Lumière Aesthetics, Cottesloe — occasionally, by email.",
  h1: "Join the Lumière list",
  standfirst: "Physician introductions, journal articles and appointment availability — occasionally, by email.",
};

const Register = () => {
  const c = COPY;
  return (
    <>
      <SEO title={c.title} description={c.description} ogImage="/images/hero-sunset.webp" />
      <div className="flex flex-col lg:grid lg:grid-cols-2 lg:min-h-screen" data-testid="register-page">
        <section className="relative order-2 lg:order-1 min-h-[52vh] lg:min-h-0 flex items-end lg:items-center" data-testid="register-visual">
          <img
            src="/images/hero-sunset.webp"
            alt="Sunset over the Indian Ocean at Cottesloe"
            className="filmic absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "50% 60%" }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[rgba(35,58,53,0.82)] via-[rgba(35,58,53,0.35)] to-[rgba(35,58,53,0.15)]" aria-hidden="true" />
          <div className="gold-frame inset-5 sm:inset-8 opacity-70 z-10" aria-hidden="true" />
          <div className="relative z-10 px-8 sm:px-12 lg:px-[120px] pt-24 pb-16 lg:py-24 max-w-2xl">
            <p className="eyebrow eyebrow-dark">Cottesloe · Perth</p>
            <h1 className="text-warm-white" data-testid="register-heading-h1">{c.h1}</h1>
            <p className="standfirst text-cream/90" data-testid="register-standfirst">{c.standfirst}</p>
          </div>
        </section>
        <section className="order-1 lg:order-2 bg-sand flex items-center" data-testid="register-panel">
          <div className="w-full px-6 sm:px-12 lg:px-16 xl:px-24 pt-28 pb-12 lg:py-24">
            <RegisterForm />
          </div>
        </section>
      </div>
    </>
  );
};

export default Register;
